<template>
  <el-row class="tac">

    <h5></h5>
    <el-menu
      default-active="0"
      class="el-menu-vertical-demo"
      @open="handleOpen"
      @close="handleClose"
      background-color="#545c64"
      text-color="#fff"
      active-text-color="#ffd04b"
    >
      <el-menu-item
        index="0"
        @click="getId(0)"
      >
        <i class="el-icon-document"></i>
        <span>{{ $tc('message.caseMenu.title',0) }}</span>
      </el-menu-item>
      <el-menu-item
        index="1"
        @click="getId(1)"
      >
        <i class="el-icon-document"></i>
        <span slot="title">{{ $tc('message.caseMenu.title',1) }}</span>
      </el-menu-item>
      <el-menu-item
        index="2"
        @click="getId(2)"
      >
        <i class="el-icon-document"></i>
        <span slot="title">{{ $tc('message.caseMenu.title',2) }}</span>
      </el-menu-item>
      <el-menu-item
        index="3"
        @click="getId(3)"
      >
        <i class="el-icon-document"></i>
        <span slot="title">{{ $tc('message.caseMenu.title',3) }}</span>
      </el-menu-item>
    </el-menu>

  </el-row>
</template>

<script>
export default {
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    getId(index) {
      this.$emit("getInfo", index);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/case/components/CaseMenu.vue